// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v_Ur","newExpiryDate":"styles_newExpiryDate__3EgZs","footer":"styles_footer__3X465"};